import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Button } from '@blueprintjs/core';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import Sticky from 'react-stickynode';
import * as DataList from 'components/DataList';
import SearchBars from 'components/SearchBars';
import SettingsPage from 'components/SettingsPage';
import FormsTable, { FORM_COLUMNS, FORM_CARDS, FORM_MIN_TABLE_WIDTH } from 'components/Tables/Forms';
import AddFormModal from 'components/Form/AddFormModal';

// Settings > Forms (/dashboard/forms). The router loads the forms
// (formStore.loadForms); Try again does the same.
@inject('formStore') @observer
class FormsIndexPage extends Component {
  @observable isAddFormOpen = false;

  openAdd = () => {
    this.isAddFormOpen = true;
  };

  render() {
    const { formStore } = this.props;
    const { isLoading, isError, objects } = formStore.forms;
    let content;
    if (isLoading) {
      content = <DataList.Loading columns={FORM_COLUMNS} cards={FORM_CARDS} minTableWidth={FORM_MIN_TABLE_WIDTH} noun="forms" rows={6} />;
    } else if (isError) {
      content = <DataList.LoadError noun="forms" onRetry={() => formStore.loadForms()} />;
    } else if (objects) {
      content = <FormsTable onAdd={this.openAdd} />;
    }
    return (
      <React.Fragment>
        <Helmet>
          <title>Forms | FieldNexus</title>
        </Helmet>
        <SettingsPage
          title="Forms"
          description="Checklists and questionnaires your team fills in on jobs."
          actions={<Button className="sp-button sp-button--primary" icon="add" text="Add form" onClick={this.openAdd} />}
        >
          <Sticky enabled={true} top={0} innerZ={9}>
            <SearchBars.Form />
          </Sticky>
          {content}
        </SettingsPage>
        <AddFormModal
          isOpen={this.isAddFormOpen}
          onClose={() => { this.isAddFormOpen = false; }}
          onSuccess={() => { this.isAddFormOpen = false; }}
        />
      </React.Fragment>
    );
  }
}

export default FormsIndexPage;
